import { render, staticRenderFns } from "./PaymentCopyDialog.vue?vue&type=template&id=b84ce226&"
import script from "./PaymentCopyDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentCopyDialog.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCopyDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports